import { Divider, Text } from "@fluentui/react-components";
import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { Flex } from "@/components/atoms/flex";
import { VoicemailContentProps } from "./types";
import { useStyle } from "./style";
import ReactPlayerWrapper from "@/components/atoms/reactPlayer/ReactPlayerWrapper";

export const VoicemailContent = (props: VoicemailContentProps) => {
	const { voicemailOverview } = props;
	const intl = useIntl();
	const style = useStyle();
	const [playerUrl, setPlayerUrl] = useState<string | null | undefined>(
		undefined
	);

	useEffect(() => {
		const controller = new AbortController();

		if (!voicemailOverview?.filePath) {
			setPlayerUrl(null);

			return () => controller.abort();
		}

		setPlayerUrl(undefined);

		fetch(voicemailOverview.filePath, {
			redirect: "manual",
			signal: controller.signal,
		})
			.then((response) => {
				if (response.type === "opaqueredirect") {
					setPlayerUrl(voicemailOverview.filePath);
				} else {
					setPlayerUrl(null);
				}
			})
			.catch(() => {
				if (!controller.signal.aborted) {
					setPlayerUrl(null);
				}
			});

		return () => controller.abort();
	}, [voicemailOverview?.filePath]);

	const getTranscriptionStatusText = () => {
		if (!voicemailOverview.isTranscriptionProcessed) {
			return intl.formatMessage({
				id: "Interaction.Voicemails.TranscriptionInProgress",
			});
		}
		if (
			voicemailOverview.transcription === "" ||
			!voicemailOverview.transcription
		) {
			return intl.formatMessage({
				id: "Interaction.Voicemails.VoicemailPoorQuality",
			});
		}

		return voicemailOverview.transcription;
	};

	const renderBottomSection = () => {
		if (playerUrl) {
			return (
				<Text className={style.transcription} align="justify">
					{getTranscriptionStatusText()}
				</Text>
			);
		}
		if (playerUrl === null) {
			return (
				<Text className={style.transcription} align="justify">
					{intl.formatMessage({
						id: "Interaction.Voicemails.RecordingNotAvailable",
					})}
				</Text>
			);
		}
		return null;
	};

	return (
		<Flex column className={style.interaction}>
			<Flex hAlign="center" vAlign="flex-start" className={style.audioPlayer}>
				{voicemailOverview.expireDate &&
				new Date(voicemailOverview.expireDate) > new Date() &&
				playerUrl ? (
					<ReactPlayerWrapper url={playerUrl} />
				) : null}
			</Flex>
			{playerUrl && <Divider className={style.middle} />}
			<Flex>{renderBottomSection()}</Flex>
		</Flex>
	);
};
